// extracted by mini-css-extract-plugin
module.exports = {"bsHeader":"bsHeader_36FQp","divider":"divider_25hKc","spinWrapper":"spinWrapper_3GQh4"};